import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const DetailWrapper = styled.div`
  display: flex;
`;
